// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__g362q","Button":"Footer_Button__Fcpm5"};